export const hasMorePageItems = (rowsCount, pageSize) => {
  const count = Number(rowsCount) || 0;
  const size = Number(pageSize) || 0;
  return size > 0 && count >= size;
};

export const mergeUniquePageItems = (current = [], incoming = [], getItemKey) => {
  const merged = [];
  const indexesByKey = new Map();

  [...current, ...incoming].forEach((item) => {
    const key = getItemKey?.(item);

    if (key == null || key === "") {
      merged.push(item);
      return;
    }

    const normalizedKey = String(key);
    const existingIndex = indexesByKey.get(normalizedKey);

    if (existingIndex == null) {
      indexesByKey.set(normalizedKey, merged.length);
      merged.push(item);
      return;
    }

    merged[existingIndex] = item;
  });

  return merged;
};
